import type {AfriexAdminAmount} from '@/types';
import {AfriexCurrencyCode} from '@/types';
import type {AfriexAssetAmount} from '@/types/MarketPlace';

export const formatAmount = (amount: {
  asset: string;
  value: string;
}): string => {
  const numeric = Number(amount.value);
  const value = Number.isFinite(numeric)
    ? numeric.toLocaleString()
    : amount.value;
  return `${value} ${amount.asset}`;
};

export const formatAmountRaw = (amount: {
  asset: string;
  value: string;
}): string => `${amount.value} ${amount.asset}`;

export const toAssetAmount = (a: AfriexAdminAmount): AfriexAssetAmount => ({
  asset: a.currency,
  value: String(a.amount ?? 0),
});

export const toAdminAmount = (a?: AfriexAssetAmount): AfriexAdminAmount =>
  ({
    currency: (a?.asset as AfriexCurrencyCode) ?? AfriexCurrencyCode.USD,
    amount: a?.value ? Number(a.value) : undefined,
  }) as AfriexAdminAmount;
